import { chartColors } from '@UILibrary/utils'

export const buildFinancialHealthHeatmapDataProp = (datasets) => {
  const colorMapping = {
    'Highly Unlikely': chartColors['financial-health-high-unlikely'],
    'Unlikely': chartColors['financial-health-unlikely'],
    'Possibly': chartColors['financial-health-possibly'],
    'Likely': chartColors['financial-health-likely'],
    'Highly likely': chartColors['financial-health-highly-likely']
  }

  return datasets.map(dataset => ({
    ...dataset,
    color: colorMapping[dataset.label] || chartColors['gray-40'],
  }))
}
